var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppointmentStatusOnfleet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.958,
    height: 33.843,
    viewBox: "0 0 31.958 33.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0-19.989 1.3 2.6 3.256-3.9",
    transform: "translate(7.21 34.303)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 3.256 3.685",
    transform: "translate(7.21 22.124)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-50.077 0-3.256 3.685",
    transform: "translate(60.543 22.124)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9077"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-390.6 0c2.546.14 4.559 1.913 4.559 4.08v21.333c0 2.259-2.187 4.089-4.884 4.089h-20.189c-2.7 0-4.884-1.831-4.884-4.089V4.08c0-2.167 2.013-3.94 4.559-4.08",
    transform: "translate(416.999 3.34)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.558-122.233H-21.6a2.329 2.329 0 0 0 2.442-2.2v-2.708a2.329 2.329 0 0 0-2.442-2.2h-15.958a2.329 2.329 0 0 0-2.442 2.2v2.708a2.329 2.329 0 0 0 2.442 2.2z",
    transform: "translate(45.559 130.333)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9078"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7829",
    d: "M0 0h18.206v18.206H0z",
    style: {
      fill: "none"
    },
    transform: "translate(13.432 10.335)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7830",
    d: "M14.109 6.62a4.044 4.044 0 0 0-2.86 1.161l-5.332 4.733A2.568 2.568 0 1 1 4.1 8.137a2.579 2.579 0 0 1 1.851.781l.857.759L7.95 8.661l-.956-.842a4.081 4.081 0 1 0-.038 5.8l5.333-4.733a2.568 2.568 0 1 1 1.821 4.377 2.592 2.592 0 0 1-1.851-.781l-.865-.766-1.145 1.016.963.85a4.088 4.088 0 1 0 2.9-6.964z",
    transform: "translate(13.432 8.737)",
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentStatusOnfleet);
export default __webpack_public_path__ + "static/media/appointment_status_onfleet.b23e0e481d03366fda1ccdc6186cd585.svg";
export { ForwardRef as ReactComponent };